
export const Checkmark = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5765_19244)">
                <rect width="32" height="32" fill="white" fillOpacity="0.01" />
                <rect width="32" height="32" rx="16" fill="#00807B" fillOpacity="0.12" />
                <g clipPath="url(#clip1_5765_19244)">
                    <path
                        d="M24.3828 10.1182C24.8711 10.6064 24.8711 11.3994 24.3828 11.8877L14.3828 21.8877C13.8945 22.376 13.1016 22.376 12.6133 21.8877L7.61328 16.8877C7.125 16.3994 7.125 15.6064 7.61328 15.1182C8.10156 14.6299 8.89453 14.6299 9.38281 15.1182L13.5 19.2314L22.6172 10.1182C23.1055 9.62988 23.8984 9.62988 24.3867 10.1182H24.3828Z"
                        fill="#00807B"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5765_19244">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
                <clipPath id="clip1_5765_19244">
                    <rect width="20" height="20" fill="white" transform="translate(6 6)" />
                </clipPath>
            </defs>
        </svg>
    );
};
